import React from "react";
import CourseCard from "./CourseCard";
import { trainings } from "../../data/clearith";

const FormationsContent: React.FC = () => (
  <section className="cl-page-section">
    <div className="container">
      <div className="cl-page-intro">
        <span className="cl-kicker">Catalogue CLEARITH</span>
        <h2 className="cl-section-title">
          Des parcours conçus pour développer et certifier des compétences
          professionnelles.
        </h2>
        <p className="cl-lead">
          La structure de notre catalogue permet d’intégrer progressivement de
          nouvelles formations tout en conservant des fiches claires et
          comparables.
        </p>
      </div>
      <div className="cl-course-grid">
        {trainings.map((training) => (
          <CourseCard key={training.slug} training={training} />
        ))}
      </div>
    </div>
  </section>
);

export default FormationsContent;
